import { ReactNode, forwardRef } from 'react';

import styles from './CollectionCompilerTemplate.module.css';

interface ICompilerProps {
  compiledNodes: ReactNode;
}

export const CollectionCompilerTemplate = forwardRef<HTMLElement, ICompilerProps>(
  ({ compiledNodes }, ref) => {
    return (
      <section id="compiler" className={styles['compiler']} ref={ref}>
        {compiledNodes}
      </section>
    );
  },
);

CollectionCompilerTemplate.displayName = 'CollectionCompilerTemplate';
